import { IOSMResponse } from '@eventr/common'
import { RowInfoAddress } from '../subComponents/rowInfoAddress'

interface HotelAddressProps {
    address: IOSMResponse
}

export const HotelAddress = ({ address }: HotelAddressProps) => {
    return <RowInfoAddress address={address} />
}
